import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Stack } from '@mui/material';
import { MODERN_COLORS, MODERN_RADIUS } from './tokens';

export const ModernPageHeader = ({ tag, title, actions, sx = {} }) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 1.5,
        ...sx,
      }}
    >
      <Box>
        {tag && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              px: 1.2,
              py: 0.25,
              borderRadius: MODERN_RADIUS.pill,
              bgcolor: MODERN_COLORS.primaryIce2,
              color: MODERN_COLORS.primaryDark,
              border: `1px solid ${MODERN_COLORS.borderSoft}`,
              fontSize: '0.675rem',
              fontWeight: 800,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              mb: 0.5,
            }}
          >
            {tag}
          </Box>
        )}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            color: MODERN_COLORS.textMain,
            lineHeight: 1.15,
          }}
        >
          {title}
        </Typography>
      </Box>

      {actions && (
        <Stack direction="row" spacing={1.5} alignItems="center">
          {actions}
        </Stack>
      )}
    </Box>
  );
};

ModernPageHeader.propTypes = {
  tag: PropTypes.string,
  title: PropTypes.node.isRequired,
  actions: PropTypes.node,
  sx: PropTypes.object,
};

export default ModernPageHeader;
